
import { Component, Input, OnChanges } from '@angular/core';

import cloneDeep from 'lodash/cloneDeep';
import { MenuItem } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-training-dashboard',
  templateUrl: './training-dashboard.component.html',
  styleUrl: './training-dashboard.component.scss'
})
export class TrainingDashboardComponent implements OnChanges {
  staticURL = GlobalConstants.staticFilesURL;
  basicData: any;
  basicOptions: any;
  progressDetails: any = []
  usersDate : any 
  skeleton : boolean = true
  piCharts: any = []
  piChartOptions: any
  dateFilter : any
  @Input() tab: string = "WEEKLY"
  fixedTypes = ['WEEKLY','Unified session','New Branch','MONTHLY']

  constructor(
    private dataService: DataService,
    public permissionService: PermissionHandlerService,
    private orgUnits: OrgUnitsService,
  ) { }


  ngOnInit() {
    this.spinner = true
    this.getChartData().then(async () => {
      await this.getTrainingTypes().then(() => { 
        this.getTreeData().then(() => this.calculateRemaining()) 
        Promise.all([
          this.getChartDataUsers(),
          this.createBarGraph(),
          this.createChartGraph(),
        ]).then(()=>this.spinner = false)
      })
      // this.spinner = false
    })
  }

  ngOnChanges() {
    this.handleTabChnage()
  }

  chartData: any
  spinner: boolean = true
  handleTabChnage() {
    this.spinner = true
    this.basicData = null
    this.piCharts = []
    this.progressDetails = []
    this.getChartData().then(() => {
      this.getTreeData().then(() => this.calculateRemaining())
      Promise.all([
        this.getChartDataUsers(),
        this.createBarGraph(),
        this.createChartGraph(),
      ]) .then(()=>this.spinner = false)
      // this.spinner = false
    })

  }

  resetFilter(){
    this.dateFilter = undefined
    this.handleTabChnage()
  }

  trainingType: any
  private async getTrainingTypes(): Promise<void> {
    let res = await this.dataService.postData('training-type/get', {
      active: true,
    });

    if (res.error) {
      return;
    }
    this.trainingType = await res.data.map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        allowed_ou: item.allowed_ou,
        name: item.name,
        icon: `pi pi-${item.icon}`,
        value: item._id,
      };
    });
  }

  private async getChartData(): Promise<void> {
    let sendTab = this.tab
    if (sendTab == 'MONTHLY') sendTab = "Unified session"

    if(!this.fixedTypes.includes(sendTab)) return

    let query : any  = {
      type : sendTab
    }

    if(this.dateFilter && this.dateFilter[0] && this.dateFilter[1]){
      query.start_date = this.dateFilter[0];
      query.end_date = this.dateFilter[1];
    }

    let res = await this.dataService.postData('training-req/get/graphs-data',query);

    if (res.error) {
      return;
    }

    this.chartData = res.data;
    
  }

  onDateRangeChange() {
    if (this.dateFilter && this.dateFilter[0] && this.dateFilter[1]) {
      this.handleTabChnage()
    }
  }

  async getChartDataUsers(): Promise<void> {
    if (!this.trainingType) {
      // Handle case where this.trainingType is undefined
      console.error('this.trainingType is undefined');
      return;
    }
  
    let sendTab = this.tab;
    if (sendTab == 'MONTHLY') sendTab = "Unified session";
    
    let filteredID = this.trainingType.find((item:any) => item.name == sendTab);
  
    if (!filteredID) {
      // Handle case where filteredID is undefined
      console.error('filteredID is undefined');
      return;
    }
  
    let query: any = {
      type: filteredID._id
    };
  
    if (this.dateFilter && this.dateFilter[0] && this.dateFilter[1]) {
      query.start_date = this.dateFilter[0];
      query.end_date = this.dateFilter[1];
    }
  
    let res = await this.dataService.postData('training-req/get/graphs-data-users', query);
  
    if (res.error) {
      console.error('Error fetching graph data:', res.error);
      return;
    }
  
    this.usersDate = res.data;
  }
  

  createBarGraph() {

    if(!this.fixedTypes.includes(this.tab)) return

    this.progressDetails = []

    this.chartData.map((item: any) => {
      this.progressDetails.push({
        percent: ((item.completed / item.total_records) * 100).toFixed(1),
        ...item
      }
      )
    })

  }


  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  getTotal() {
    return this.chartData?.reduce((sum: any, item: any) => sum + item.total_records, 0);
  }


  trainingNotSend: any = []

  calculateRemaining() {
    let allBranches = this.selectedTreeData[0]?.children[0]?.children
    this.trainingNotSend = allBranches.filter((secondItem: any) => {
      return !this.chartData.some((e: any) => e._id == secondItem._id)
    });
  }


  createChartGraph() {

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = 'white';
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
    this.piCharts = []
    this.chartData?.map((item: any) => {
      this.piCharts.push(
        {
          chatData: {
            datasets: [
              {
                data: [item.pending, item.approved_records, item.draft, item.published_records, item.completed, item.rejected_records],
                backgroundColor: [
                  '#FACB7D',
                  '#6648FF',
                  '#703D94',
                  '#F7517F',
                  '#3F4357',
                  '#16CEB9',
                  ],
                label: ` ${item?.ou?.name} (${item.location.name})`
              }
            ],
            labels: [this.translate('pending'), this.translate('Accepted'), this.translate('Draft'), this.translate('Published'), this.translate('completed'), this.translate('Rejected')]
          },
          data: item
        }
      )
    })

    console.log("-> char pie", this.piCharts)
    


    this.piChartOptions = {
      plugins: {
          legend: {
              labels: {
                  usePointStyle: true,
                  color: textColor,
                  font: {
                    size: 14,
                    family: 'SSTArabic',
                  },
              }
          }
      }
  };

  }

  visible = false

  translator: TranslatorPipe = new TranslatorPipe()
  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }


  // Tree Graph work


  async getTreeData() {
    let data: any = await await this.orgUnits.getOrgUnits();
    this.selectedTreeData = [];

    // Check if this.trainingType exists and is not empty
    if (this.trainingType && this.trainingType.length > 0) {
        //get weekly type
        let selectedid: any = this.trainingType.find((e: any) => e.name == this.tab).allowed_ou;

        if (selectedid.label != 'الجهات المشاركة') {
            this.selectedTreeData.push(this.findNodeByName(data, selectedid._id));
            // Create a deep copy of the selected data using lodash.clonedeep
            this.selectedTreeData_orginal = cloneDeep(this.selectedTreeData);
            console.log("the selected tree 109", this.selectedTreeData);

            const uniqueTags = new Set();

            this.types.forEach((type: any) => {
                if (type && type.tag) {
                    uniqueTags.add(type.tag);
                }
            });

            let uniqueTagsArray: MenuItem[] = [];

            uniqueTags.forEach((item: any) => {
                if (item != "Ministries/Entities") {
                    uniqueTagsArray.push({ label: item });
                }
            });

            this.selectedTreeTags = uniqueTagsArray;

            this.selectedTreeTags_current = this.selectedTreeTags[0];

            this.changeSelectedTag(this.selectedTreeTags_current);
        }
    } else {
        console.error("Training types not found or empty.");
    }
}


  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      if (node._id === nodeName) {
        return node;
      }

      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  async changeSelectedTag(event: any) {
    console.log("change tag event", event);
    this.selectedTreeTags_current = {
      "label": "Branches"
    };
    if (this.selectedTreeTags_current.label) {
      await this.filterTreeByTag("Branches");
    } else {
      this.selectedTreeData = null;
    }

  }


  selectedTreeData: any = []
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  filterTreeByTag(tag: string) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });

      console.log("cloneitems.children", cloneitems);
      this.selectedTreeData = cloneDeep(cloneitems);

      console.log("cloneitems.children this.selectedTreeData", this.selectedTreeData);
    }
  }

  filterNodes(node: any, tag: string): any | null {
    // Recursively filter children nodes
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }




  
 


}
